import { useRouteError } from 'react-router-dom';
import { ErrorMessage } from '@/components/ErrorMessage/ErrorMessage';
import { StaleVersionFallback } from '@/components/StaleVersionFallback/StaleVersionFallback';
import { isChunkLoadError, reloadApp } from '@/helpers/appVersion';

export const RouteErrorFallback = () => {
  const error = useRouteError();

  if (isChunkLoadError(error)) {
    return <StaleVersionFallback />;
  }

  const message = error instanceof Error ? error.message : 'An unexpected error occurred';

  return <ErrorMessage message={message} retry={reloadApp} />;
};
